var map = {
	"./views/clients/clients.module": [
		"../../../../../src/app/views/clients/clients.module.ts",
		"clients.module",
		"common"
	],
	"./views/devices/devices.module": [
		"../../../../../src/app/views/devices/devices.module.ts",
		"devices.module",
		"common"
	],
	"./views/pages/pages.module": [
		"../../../../../src/app/views/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./views/partners/partners.module": [
		"../../../../../src/app/views/partners/partners.module.ts",
		"partners.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/bruna/Desktop/nuresp/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main